import React from 'react';
import {getAssetUrl} from "../../utils/getAssetUrl";
import BackgroundImage from './images/main_background.jpg';
import BannerImage from './images/banner.png';
import ProductionTitleImage from './images/clien-game-title.png';
import Jx3GameImage from './images/wbl_jx3.png';
import Jx3YqGameImage from './images/wbl_jx3yq.png';
import GameItem from "./components/GameItem";
import Footer from "./components/Footer";
import Layout from "../../components/Layout";


const styles = require('./index.module.less');

const env = process.env.NEXT_PUBLIC_ENV;

const IndexPageComponent: React.FC = () => {
  return (
    <Layout>
      <div className={styles.container} style={{background: `url(${getAssetUrl(BackgroundImage.src)}) no-repeat center 222px`}}>
        <div className={styles.subContainer} style={{background: `url(${getAssetUrl(BannerImage.src)}) no-repeat center -103px`}}>
          <div className={styles.productionListContainer}>
            <div className={styles.titleContainer}>
              <img src={getAssetUrl(ProductionTitleImage.src)} />
            </div>
            <div className={styles.listContainer}>
              <GameItem src={getAssetUrl(Jx3GameImage.src)} link={'https://jx3.seasunwbl.com'} title={'《剑网3重制版》'} />
              <GameItem src={getAssetUrl(Jx3YqGameImage.src)} link={'https://jx3yq.seasunwbl.com'} title={'《剑网3缘起》'} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Layout>
  )
}
export default IndexPageComponent;
